export function initDraggablePanels(): void {
  const panels = document.querySelectorAll<HTMLElement>('.floating-panel');

  for (let i = 0; i < panels.length; i++) {
    const panel = panels[i];
    setupDrag(panel);
    setupCollapse(panel);
  }
}

function setupDrag(panel: HTMLElement): void {
  const header = panel.querySelector<HTMLElement>('.panel-header');
  if (!header) return;

  let offsetX = 0;
  let offsetY = 0;
  let dragging = false;

  header.addEventListener('mousedown', (e: MouseEvent) => {
    if ((e.target as HTMLElement).closest('.collapse-btn')) return;

    dragging = true;
    panel.classList.add('dragging');

    const rect = panel.getBoundingClientRect();
    offsetX = e.clientX - rect.left;
    offsetY = e.clientY - rect.top;

    e.preventDefault();
  });

  window.addEventListener('mousemove', (e: MouseEvent) => {
    if (!dragging) return;

    let newX = e.clientX - offsetX;
    let newY = e.clientY - offsetY;

    newX = Math.max(0, Math.min(window.innerWidth - 50, newX));
    newY = Math.max(0, Math.min(window.innerHeight - 50, newY));

    panel.style.left = newX + 'px';
    panel.style.top = newY + 'px';
    panel.style.right = 'auto';
    panel.style.bottom = 'auto';
    panel.style.transform = 'none';
  });

  window.addEventListener('mouseup', () => {
    if (dragging) {
      dragging = false;
      panel.classList.remove('dragging');
    }
  });
}

function setupCollapse(panel: HTMLElement): void {
  const btn = panel.querySelector<HTMLElement>('.collapse-btn');
  if (!btn) return;

  btn.addEventListener('click', () => {
    panel.classList.toggle('collapsed');
    btn.textContent = panel.classList.contains('collapsed') ? '+' : '\u2212';
  });
}
